// import the library
import { library } from '@fortawesome/fontawesome-svg-core';

// import your icons
//import { fab, faFirefox } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faFacebook, faInstagram, faTwitter, faDiscord, faTwitch, faYoutube, faMixcloud, faSoundcloud } from '@fortawesome/free-brands-svg-icons';
import { faPlay, faPause, faStop, faRepeat, faUser, faHeart, faThumbsUp, faVolumeHigh, faVolumeXmark, faXmark, faFileArrowDown, faBars, faTv, faSquareUpRight, faCompactDisc, faHourglassEmpty, faCaretDown, faCaretUp, faExpandAlt, faImage, faImages, faTicket, faGear, faEllipsis, faArrowUpFromBracket, faDonate, faHeadphones, faUserGroup, faHouseUser, faScrewdriverWrench, faCalendarDays, faChartLine, faLock, faRightFromBracket, faMagnifyingGlass, faGlobeEurope, faList, faMusic, faCirclePlus, faCircleRight, faCloudArrowUp, faBackward, faCircleInfo, faUpLong, faDownLong, faCheck, faEye, faTrash, faTriangleExclamation, faLocationDot, faRedo, faReply, faCircleLeft, faBell, faRectangleAd, faShare, faTrophy } from '@fortawesome/free-solid-svg-icons';
//import { faClock } from '@fortawesome/react-fontawesome';
import { faClock, faAddressCard, faCalendar, faClipboard } from '@fortawesome/free-regular-svg-icons';

library.add(

		faEye, // register
		faFacebookF,
		faInstagram,
		faTwitter,
		faDiscord,
    // not used
    //fab,
		faPlay, // audio
		faPause, // audio
		faStop, // video
		faRepeat, // audio
		faUser, //audio
		faHeart, //audio
		faThumbsUp, //audio
		faSquareUpRight, // audio
		//faDowntoline, //audio
	
		faFileArrowDown, // audio
		faBars, //audio
		//faTentArrowDownToLine

		faCircleLeft, // index
		
		
		faAddressCard, // header
		faCalendar, // header
		faUserGroup, // header
		faClipboard, // header
		faHouseUser, // header
		faScrewdriverWrench, // header
		faFacebook, // header
		faCalendarDays, // header
		faChartLine, // header
		faLock, // header
		faMagnifyingGlass, // header
		faRightFromBracket, // header
		faBell, // header
		faRectangleAd, // header
		faTrophy, // header

		faVolumeHigh, // mix365socket
		faVolumeXmark, // audioplayer
		faXmark, // mix365socket

		faTv, //live
		faGlobeEurope, // live
		faList, // live
		faMusic, // live
		faShare, // live

		faTrash, // schedule

		faCompactDisc, // about
		faHourglassEmpty, // about

		faCaretDown, // statistics
		faCaretUp, // header

		faExpandAlt, // video
		faImages, // video
		faTicket, // video
		faTriangleExclamation, // video
		faArrowUpFromBracket, // livechat
		faDonate, // livechat
		faHeadphones, // livechat
		faClock, // livechat

		faBackward, // chatbox
		faGear, // chatbox
		faEllipsis, // chatbox
		faCirclePlus, // chatbox
		faCircleRight, // chatbox
		faImage, // chatbox
		faCloudArrowUp, // chatbox
		faCircleInfo, // chatbox
		faCheck, // chattbox
		faReply, // chatbox

		faTwitch, // index
		faYoutube, // index
		faMixcloud, // index
		faSoundcloud, //index

		faUpLong, // test
		faDownLong, // test

		faLocationDot, // profile

		faRedo, // socket
		
);

/*
<FontAwesomeIcon icon={['fab', 'firefox']} />
*/